<!-- Managers the addition of team members to a team -->
<template>
    <div class="flex flex-col w-full mx-1 lg:mt-0 mt-2 overflow-x-hidden" style="scrollbar-width: thin;">
        <div class="flex flex-col border-2 rounded py-1 px-4 w-fit h-full w-full ">
            <div class="flex flex-col min-w-max justify-center">
                <label class="font-bold text-center min-w-max block w-auto justify-center flex mr-3">
                    Add Player:
                </label>
                <div v-if="errorMessage.length !== 0 && !isLoading" class=" flex justify-center pb-0.5">
                    <span class="text-red-500 text-xs"> {{ errorMessage }} </span>
                </div>
                <div class="flex justify-center">
                    <InputGroup class="max-w-80">
                        <InputText v-model="searchText" placeholder="Enter Name or Id" id="searchInput"
                            @dragenter="search()" @ended="search()" @keypress="listenForEnter($event)"
                            class="text-center rounded-l-md border-2 shadow-none min-w-fit h-6 text-black-900 w-60 border-r-0 bg-white" />
                        <Button :icon="!isLoading ? 'pi pi-search' : 'pi pi-spin pi-spinner'"
                            class="bg-[#1f2937] hover:bg-slate-500 text-white font-semi h-6 py-0 px-2 rounded-r"
                            @click="search()" />
                    </InputGroup>
                </div>
            </div>
            <div v-if="!isLoading && errorMessage.length == 0"
                class="overflow-y-auto overflow-x-auto max-h-48 mt-0.25 w-full" style="scrollbar-width: thin;">
                <div v-if="searchResponse.length !== 0" class=" playerSelect w-full pr-1">
                    <div v-for="player, index in searchResponse" :key="player.id"
                        class="min-w-fit ml-0.5 mr-0.5 p-2 pb-1.5 mt-1 border rounded w-full">
                        <ul class="w-full">
                            <li class="flex justify-between ">
                                <div>
                                    <span class="font-bold"> {{ player.firstName }} {{ player.lastName }}</span>
                                    <Button type="button" icon="pi pi-info-circle" @mouseover="toggle($event, player)"
                                        class="font-semibold w-auto pl-2" />
                                </div>

                                <Button icon="pi pi-user-plus"
                                    class="bg-[#1f2937] hover:bg-slate-500 text-white font-semi h-6 py-0 px-2 rounded ml-0.5"
                                    @click="$emit('addPlayer', player); searchResponse.splice(index, 1); if (searchResponse.length == 0) { searchText = ''; searchResponse = []; resultMessage = undefined };">
                                </Button>
                            </li>
                            <li>
                                <span class="flex justify-between pt-0.5"> {{ player.country }}
                                    <span class="pr-2 pt-0.5" v-if="player.gender == 'Male'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.4em"
                                            viewBox="0 0 24 24">
                                            <g fill="none" fill-rule="evenodd">
                                                <path
                                                    d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                                                <path fill="#243045"
                                                    d="M21 9a1 1 0 1 1-2 0V6.414l-3.537 3.537a7.5 7.5 0 1 1-1.414-1.414L17.586 5H15a1 1 0 1 1 0-2h4.75c.69 0 1.25.56 1.25 1.25zM9.5 9a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11" />
                                            </g>
                                        </svg>
                                    </span>
                                    <span class="pr-2 pt-0.5" v-else>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em"
                                            viewBox="0 0 512 512">
                                            <path fill="#243045"
                                                d="M256 25.438a136.24 136.24 0 0 0-96.188 39.843A136.17 136.17 0 0 0 120 161.5a136.07 136.07 0 0 0 39.845 96.125a136.2 136.2 0 0 0 44.124 29.47l.218.092c10.032 4.135 20.52 7.02 31.218 8.657l.125 18.906l.314 49.188H165.97v40h70.124l.375 62.875l.124 20l40-.25l-.125-20l-.376-62.625h69.937v-40h-70.186l-.313-49.438l-.124-18.47a136 136 0 0 0 32.625-8.936a136.2 136.2 0 0 0 44.126-29.47a136.1 136.1 0 0 0 29.47-44.093a136.2 136.2 0 0 0 10.374-52.03c.005-17.84-3.52-35.58-10.344-52.063c-6.823-16.482-16.856-31.54-29.47-44.156a136.1 136.1 0 0 0-44.123-29.468a136.3 136.3 0 0 0-52.063-10.374zm0 40a96.6 96.6 0 0 1 36.75 7.312c11.58 4.798 22.294 11.947 31.156 20.813c8.863 8.865 15.987 19.573 20.78 31.156c4.796 11.58 7.318 24.213 7.314 36.75c-.004 12.53-2.515 25.173-7.313 36.75c-4.797 11.575-11.95 22.264-20.812 31.124a96.6 96.6 0 0 1-31.156 20.812c-11.58 4.795-24.19 7.28-36.72 7.28c-12.53.002-25.14-2.485-36.72-7.28a96.7 96.7 0 0 1-31.155-20.812c-8.862-8.86-16.015-19.55-20.813-31.125c-4.797-11.577-7.308-24.22-7.312-36.75c-.004-12.537 2.518-25.17 7.313-36.75c4.794-11.584 11.918-22.292 20.78-31.157c8.863-8.866 19.576-16.015 31.157-20.813a96.6 96.6 0 0 1 36.75-7.313z" />
                                        </svg>
                                    </span>
                                </span>
                            </li>
                            <li>
                                <span> {{ player.id }} </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="searchText.length !== 0" class="w-full p-2">{{ resultMessage }}</div>
            </div>
        </div>
        <slot></slot>
        <OverlayPanel ref="op">
            <div class="w-32 min-w-max grid">
                <li v-for=" info, key in infoOnSearchedPlayer" :key="key" class="list-none text-xs ">
                    <label class=" mb-2 w-1/3 text-center min-w-max px-1" v-if="info.length !== 0"> {{ key }}: </label>
                    <span class="font-semibold" v-if="info.length !== 0">{{ info.toString() }}</span>
                </li>
            </div>
        </OverlayPanel>
    </div>
</template>

<script lang="ts" setup>
import { GenderEnum, BattingHandEnum, BowlingStyleEnum, Player } from '@/models/vscoreModels'

import InputText from 'primevue/inputtext';
import OverlayPanel from 'primevue/overlaypanel';
import { defineEmits, ref, Ref, inject } from 'vue';
// import { usePlayApiStore } from "../store/api/playApi";

import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';

// const playApi = usePlayApiStore()
defineEmits(['addPlayer'])
const isLoading = ref(false)
const infoOnSearchedPlayer: Ref<any> = ref({})

const searchText = ref("")
const searchResponse: Ref<Player[]> = ref([])
const errorMessage = ref("")
const op = ref();
const resultMessage = ref()
const data: any = inject('data')
const players: Array<Player> = data.value[2]

/**
 * triggers overlay popup displaying more detailed information on searched player
 * @param event on info icon click
 * @param player to show info for
 */
const toggle = (event: any, player: any) => {
    Object.keys(player).forEach((key: string) => {
        switch (key) {
            case "gender":
                infoOnSearchedPlayer.value["Gender"] = player[key]
                break;
            // case "bowlHandedness":
            //     infoOnSearchedPlayer.value["Bowl Handedness"] = "-"
            //     break;
            case "bowlType":
                infoOnSearchedPlayer.value["Bowl Type"] = BowlingStyleEnum[player[key]]
                break;
            // case "paceType":
            //     infoOnSearchedPlayer.value["Pace Type"] = "-"
            //     break;
            // case "spinType":
            //     infoOnSearchedPlayer.value["Spin Type"] = "-"
            //     break;
            case "batHandedness":
                infoOnSearchedPlayer.value["Bat Handedness"] = BattingHandEnum[player[key]]
                break;
            // case "primaryRole":
            //     infoOnSearchedPlayer.value["Primary Role"] = "-"
            //     break;
            default:
                infoOnSearchedPlayer.value[key[0].toUpperCase() + key.slice(1)] = player[key]
                break;
        }
    });
    // infoOnSearchedPlayer.value = player
    op.value.toggle(event);
}
/**
 * listen for enter key to trigger search
 * @param event key Press Event
 */
function listenForEnter(event: { key: string; }) {
    if (event.key == "Enter") {
        search()
    }
}

/**
 * Search for player by Name and Id
 */
async function search() {
    console.log("search")
    isLoading.value = true
    errorMessage.value = ""
    searchResponse.value = []
    // if (searchText.value.length > 2) {
    players.forEach((player: Player) => {
        if (player.name.toLocaleLowerCase().includes(searchText.value.toLocaleLowerCase())) {
            searchResponse.value.push(player)
        } else if (player.id === searchText.value.toUpperCase()) {
            searchResponse.value.push(player)
            return
        }
    });
    // } else {
    // errorMessage.value = "Search input must have 3 or more charaters"
    // }
    if (searchResponse.value.length == 0) {
        resultMessage.value = "No Results"
    }
    isLoading.value = false
}
</script>

<style>
.pi-search,
.pi-user-plus,
.pi-spinner {
    color: white;
}

.pi-spinner {
    font-weight: bold;
}

ul {
    list-style-type: none;
}

.playerSelect {
    display: grid;
    grid-template-rows: auto;
    grid-auto-rows: auto;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    gap: 2px;
}
</style>